<div fxLayout="row" fxLayoutAlign="start center">
  <div
    class="color-display"
    [ngStyle]="{ 'width.px': size, 'height.px': size, 'border-radius.px': radius, 'background-color': htmlColorCode }"
  ></div>
  @if (showHtmlColorCode) {
    <div class="color-label">{{ htmlColorCode }}</div>
  }
</div>
